import { Result, validatedApiCall } from '../api';
import { APIValidationError } from '../../types/api/api';
import { ActivitatsFilters } from './getActivitats';
import toQueryParams from '../../utils/toQueryParams';

export interface ActivitatsExport {
  content: string;
}

export type GetExportActivitatsDTO = ActivitatsFilters;

export const getExportActivitats = async (
  data: GetExportActivitatsDTO,
): Promise<Result<ActivitatsExport, APIValidationError>> => {
  return validatedApiCall<ActivitatsExport>(
    `/api/activitats/exports/csv?${toQueryParams(
      data as unknown as Record<string, string>,
    )}`,
    {
      method: 'GET',
      auth: true,
    },
  );
};
